import { LoaderFunction } from 'react-router-dom';
import debug from 'debug';

// Types
import { decompressSessionStorage } from '../../../../../utils/sessionStorage';

// Constants
import { formActionNaming } from '../../../../../components/forms/ActionForms/constants';
import { claimDraftScope } from '../../../../../utils/draftOwnership';
import {
  ACTION_CREATION_SCOPE,
  ACTION_MEDIA_SCOPE,
  readCreationDraftId,
} from '../../../../../utils/draftScopes';
import { foreignCreationParentRedirect } from '../creationDraft';

export const BudgetItemsLoader: LoaderFunction | undefined = async ({ params, request }) => {
  // Un borrador de OTRO padre no se abre bajo esta URL: atrás, una URL
  // compartida o el «Editar» de un resumen viejo enseñaban — y guardaban — el
  // borrador de la OT Y bajo la de la X (auditoría de creación 2.3).
  const foreignParent = foreignCreationParentRedirect({ params, request });
  if (foreignParent) return foreignParent;
  // Las copias de las pestañas, la lista de fotos y el croquis son del
  // borrador en curso (`draftId`): si eran de otro, fuera, antes de que nadie
  // las lea. Síncrono y antes de cualquier `await`: el loader de `details` y el
  // de la pestaña corren en paralelo (spec 2026-11-02 wizard-draft-ownership).
  const draftId = readCreationDraftId();
  claimDraftScope(ACTION_CREATION_SCOPE, draftId);
  claimDraftScope(ACTION_MEDIA_SCOPE, draftId);

  // El trabajo entero vive aquí dentro, íntegro. Solo ha dejado de
  // esperarse: la promesa tiene que llegar PENDIENTE al `<Await>` para que
  // el router termine la navegación al instante y el `<Fallback>` enseñe el
  // Loader DENTRO de la pantalla nueva.
  const load = async () => {
  const logBudgetLoader = debug('rois:budgetitems:loader:newaction');

  logBudgetLoader('🔍 [NewAction] Iniciando carga de Budget Items');

  // ✅ ESTRUCTURA ESTÁNDAR: Igual que Materials

  // Stringify data (igual que Materials)
  const stringifyForm = sessionStorage.getItem(
    formActionNaming.NEW_BUDGET_ITEMS_FORM
  );

  const breadCrumbsDataStringify = sessionStorage.getItem(
    formActionNaming.NEW_ACTION_DATA
  );

  logBudgetLoader(
    '📦 [NewAction] SessionStorage NEW_BUDGET_ITEMS_FORM:',
    stringifyForm
  );
  logBudgetLoader(
    '📦 [NewAction] SessionStorage NEW_ACTION_DATA:',
    breadCrumbsDataStringify
  );

  // Variables to assign (igual que Materials)
  let sessionStorageData;
  let breadCrumbsData;

  // Variables Assignment (igual que Materials)
  if (stringifyForm) {
    sessionStorageData = JSON.parse(decompressSessionStorage(stringifyForm));
    logBudgetLoader(
      '📦 [NewAction] SessionStorage data parsed:',
      sessionStorageData
    );
  }

  if (breadCrumbsDataStringify) {
    breadCrumbsData = JSON.parse(
      decompressSessionStorage(breadCrumbsDataStringify)
    );
    logBudgetLoader('📦 [NewAction] BreadCrumbs data parsed:', breadCrumbsData);
  }

  // ✅ NO hacer queries al servidor (NewAction no necesita datos existentes)
  // A diferencia de Materials que fetch materials disponibles,
  // BudgetItems se seleccionan dinámicamente por categoría

  const combinedData = {
    ...sessionStorageData,
    // ✅ budgetItemsData: Lista vacía (no hay "budget items disponibles" predefinidos)
    // Los budget items se obtienen dinámicamente por categoría en BudgetItemSelector
    budgetItemsData: [],
    breadCrumbsData: {
      orderParentId: breadCrumbsData?.orderParentId,
      orderParentRoid: breadCrumbsData?.orderParentRoid,
    },
  };

  logBudgetLoader('✅ [NewAction] Combined data final:', combinedData);

  return combinedData;
};

  return { data: load() };
};
